import React, { useEffect, useState } from 'react'
import useStyles from './style'
import { Button, IconButton, InputAdornment, Popover, TextField, Grid, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { CheckBox, NavigateBefore, NavigateNext, Search } from "@mui/icons-material"
import clsx from 'clsx';
import moment from 'moment';

const TransactionToolbar = ({
    onSubmit = () => { },
    inputValue,
    setInputValue,
    dateFilter,
    setDateFilter,
    statusFilter,
    setStatusFilter,
    setKeyFilter,
    keyFilter

}) => {
    const classes = useStyles();
    // const [inputValue, setInputValue] = useState("")
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorFilterEl, setAnchorFilterEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handlePopoverFilterOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorFilterEl(event.currentTarget);
    };

    const handlePopoverFilterClose = () => {
        setAnchorFilterEl(null);
    };

    useEffect(() => {

        console.log(keyFilter)
    }, [inputValue])

    const open = Boolean(anchorEl);
    const openFilter = Boolean(anchorFilterEl);

    const handleChange = (event) => {
        setStatusFilter(event.target.value);
    };
    const handleChangeSearch = (e) =>{
        setKeyFilter(e.target.value)
    }

    return (
        <div className={classes.root}>
            <form onSubmit={onSubmit} id="search_box" style={{ padding: "0px 25px" }}>
                <Grid container alignItems='center' justifyContent='space-between' className={classes.toolbarContainer} spacing={1}>
                    <Box>
                        <TextField
                            variant='standard'
                            className={classes.searchBar}
                            placeholder={keyFilter ==='id'?'Nhập mã':'Nhập email'}
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            sx={{
                                '& .MuiInput-underline:before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:after    ': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline.Mui-focused:before': { borderBottomColor: '#41B60B' },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton type="submit" className={classes.buttonSearch}>
                                            <Search className={classes.iconSearch}>search</Search>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                style: { fontSize: 16 }
                            }}
                            name="id"
                        />
                        <FormControl variant="standard" sx={{ ml: 3, paddingTop: '10px', minWidth: 60,      
                                '& .MuiInput-underline:before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:after    ': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline.Mui-focused:before': { borderBottomColor: '#41B60B' }, }}>
                            <Select
                                // value={statusFilter}
                                value={keyFilter}
                                onChange={handleChangeSearch}
                                style={{color:'#5D5D5D '}}
                            >
                                <MenuItem value='email'>Email</MenuItem>
                                <MenuItem value='id'>Id đơn hàng</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl variant="standard" sx={{ ml: 1, minWidth: 100, marginTop: '-6px',      
                                    '& .MuiInput-underline:before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:after    ': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline.Mui-focused:before': { borderBottomColor: '#41B60B' }, }}>
                        <InputLabel style={{color:'#41B60B'}}>Tình trạng</InputLabel>
                        <Select
                            value={statusFilter}
                            onChange={handleChange}
                            label="Tình trạng"
                            style={{color:'#5D5D5D '}}
                            
                        >
                            <MenuItem value="">
                                All
                            </MenuItem>
                            <MenuItem value="pending">Pending</MenuItem>
                            <MenuItem value='success'>Confirm</MenuItem>
                            <MenuItem value='failure'>Cancel</MenuItem>
                        </Select>
                    </FormControl>
                    </Box>
                    
                    <Box sx={{ display: 'flex', '& button': { margin: '0px 5px', textTransform: 'none', padding: "0px 15px" } }}>
                    
                        <Button variant="outlined"
                            style={{ border: "1px solid #41B60B" }}
                            className={classes.iconNavigateCalendar}
                            onClick={() => setDateFilter(moment(dateFilter).subtract(1, 'day').format('YYYY-MM-DD'))}
                        >
                            <NavigateBefore />
                        </Button>
                        <Button variant="outlined" size='small'
                            style={{ border: "1px solid #41B60B" }}
                            className={clsx(classes.btnToday)}
                            onClick={(e) => {
                                setDateFilter(moment().format('YYYY-MM-DD'))
                            }}
                        >
                            {"Hôm nay"}
                        </Button>
                        <Button variant="outlined" className={classes.calendarBtn}>
                            <TextField
                                sx={{ "& fieldset": { border: 'none' } }}
                                id="date"
                                label=""
                                type="date"
                                value={dateFilter}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    className: classes.inputDate
                                }}
                                onChange={(e) => {
                                    setDateFilter(e.target.value)
                                }}
                            />
                        </Button>
                        <Button color="primary" variant="outlined"
                            style={{ border: "1px solid #41B60B" }}
                            className={clsx(classes.iconNavigateCalendar)}
                            onClick={() => setDateFilter(moment(dateFilter).add(1, 'day').format('YYYY-MM-DD'))}
                        >
                            <NavigateNext />
                        </Button>
                    </Box>

                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                            paper: classes.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '468px', padding: '32px' }}>
                            <Box sx={{ width: '100%', textAlign: 'center', fontSize: '18px', color: '#131313', mb: 3 }}>Lấy lại code cho user</Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                '& .MuiInputBase-root': {
                                    margin: '17px auto',
                                    width: '100%',
                                    fontSize: '14px'
                                }
                            }}
                            >
                                <TextField placeholder='Email' />
                                <TextField placeholder='ID code động' />
                                <TextField placeholder='URL cuối' />
                            </Box>
                            <Box sx={{
                                display: 'flex', justifyContent: 'flex-end', '& button': {
                                    margin: '0px 5px',
                                    textTransform: 'none'
                                }
                            }}>
                                <Button variant='contained' size='large' onClick={() => setAnchorEl(null)}>Hủy</Button>
                                <Button variant='contained' color="primary" size='large'>Tạo code</Button>
                            </Box>
                        </Box>
                    </Popover>

                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                            paper: classes.paper,
                        }}
                        open={openFilter}
                        anchorEl={anchorFilterEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverFilterClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '360px', padding: '32px' }}>
                            <Box sx={{ width: '100%', textAlign: 'left', fontSize: '18px', color: '#131313', mb: 3 }}>
                                Lọc theo gói dịch vụ
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%' }}>
                                    <CheckBox color='primary'></CheckBox>
                                    <Box sx={{ ml: 1 }}>Gói DV cơ bản</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%' }}>
                                    <CheckBox color='primary'></CheckBox>
                                    <Box sx={{ ml: 1 }}>Gói DV nâng cao</Box>
                                </Box>

                            </Box>
                            <Box sx={{
                                display: 'flex', mt: 6, justifyContent: 'flex-end', '& button': {
                                    margin: '0px 5px',
                                    padding: '5px 45px',
                                    textTransform: 'none'
                                }
                            }}>
                                <Button variant='contained' color="primary" size='large'>Lọc</Button>
                            </Box>
                        </Box>
                    </Popover>
                </Grid>
            </form>
        </div>
    )
}

TransactionToolbar.propTypes = {}

TransactionToolbar.defaultProps = {}

export default TransactionToolbar;